<template>
  <div>
    <v-stepper-step :complete="currentStep > isStep" :editable="currentStep > isStep" :step="isStep">Ad Hoc Charges</v-stepper-step>

    <v-stepper-content :step="isStep">

    <template v-if="adhoc.length">
      <v-row v-for="(item, index) in adhoc" :key="index">
        <v-col class="addons_column">
          <v-card class="addons_singleaddon d-flex justify-space-between align-center">
            <div class="d-flex justify-start align-center">
              <div>
                <v-checkbox v-model="item.checked" disabled hide-details />
              </div>
              <div>{{item.name}}</div>
            </div>

            <div class="d-flex justify-end align-center">
              <div class="d-flex addons_quantity mr-1">
                <v-text-field :value="item.quantity" type="tel" label="Quantity" readonly dense outlined hide-details />
              </div>

              <div class="d-flex addons_price">
                <v-text-field :value="item.price * item.quantity | formatCurrency" type="tel" label="Total" readonly dense outlined hide-details />
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <v-row >
        <v-col>
          <div>There are no required charges for the selected tariff.</div>
        </v-col>
      </v-row>
    </template>

    <v-divider></v-divider>

    <v-row>
      <v-col>
        <v-btn color="primary" class="my-0" @click="nextStep">Continue</v-btn>
      </v-col>
    </v-row>
    </v-stepper-content>
  </div>
</template>

<script>
  export default {
    props: ['currentStep','isStep','adhoc'],
    
    methods: {
      nextStep() {
        this.$emit('continue');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .theme--light.v-stepper--vertical {
    .v-stepper__step {
      padding: 15px;
      margin: 10px;
    }
  }

  ::v-deep {
    .v-input--checkbox {
      margin-top: 0;
      padding-top: 0;
    }
  }

  .addons_column {
    padding: 0 13px;
    margin-bottom: 12px;
  }

  .addons_singleaddon {
    padding: 5px 10px;
  }

  .addons_select {
    width: 200px;
  }
  
  .addons_price,
  .addons_quantity {
    width: 80px;
  }
</style>
